import { login } from '@actions/authentication';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { LoginPage } from './LoginPage';

const mapStateToProps = (state) => ({
  successfulLogin: state.authentication.successfulLogin,
  loginLoading: state.authentication.loginLoading,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      login,
    },
    dispatch,
  ),
  forgotPasswordOnClick: () => dispatch(push('/forgot-password')),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginPage);



// WEBPACK FOOTER //
// ./components/pages/LoginPage/index.js